import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { workspacesQueryOptions } from '../../hooks/useWorkspaces'
import { authClient } from '../../lib/auth-client'

export const Route = createFileRoute('/workspaces')({
  beforeLoad: async ({ context }) => {
    const { data: session } = await authClient.getSession()
    if (!session) {
      throw redirect({ to: '/login' })
    }
    await context.queryClient.ensureQueryData(workspacesQueryOptions())
    return { session }
  },
  component: () => <Outlet />,
})
